var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "print-documents" },
    [
      _c(
        "b-button",
        {
          attrs: {
            block: "",
            disabled: !_vm.canPrintDocuments,
            variant: "primary",
          },
          on: {
            click: function ($event) {
              _vm.isModalOpen = true
              _vm.$emit("modal-opened")
            },
          },
        },
        [_vm._v(_vm._s(_vm.modalType))]
      ),
      _vm._v(" "),
      _c("b-modal", {
        attrs: {
          "cancel-disabled": true,
          "hide-footer": true,
          "ok-disabled": true,
          size: "lg",
          title: "E-Mail versenden",
        },
        scopedSlots: _vm._u(
          [
            _vm.documentMailSelectedPath && _vm.documentMailSelected
              ? {
                  key: "default",
                  fn: function ({ visible }) {
                    return [
                      visible
                        ? _c(
                            "div",
                            { staticClass: "print-documents-modal-content" },
                            [
                              _c("csp-record-detail-document-mail", {
                                ref: "documentMail",
                                attrs: {
                                  "mail-document": _vm.documentMailSelected,
                                  path: _vm.documentMailSelectedPath,
                                },
                                on: {
                                  "cancel-mail": _vm.cancelMail,
                                  "close-mail-modal": function ($event) {
                                    _vm.isMailModalOpen = false
                                  },
                                  "mail-sent": function ($event) {
                                    return _vm.$emit("document-generated")
                                  },
                                  "mail-validation-error":
                                    _vm.handleMailValidationError,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.isMailModalOpen,
          callback: function ($$v) {
            _vm.isMailModalOpen = $$v
          },
          expression: "isMailModalOpen",
        },
      }),
      _vm._v(" "),
      _c("b-modal", {
        attrs: { size: "lg", title: _vm.modalType },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ visible }) {
              return [
                visible
                  ? _c(
                      "div",
                      { staticClass: "print-documents-modal-content" },
                      [
                        !_vm.documentsLoaded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "loading-content-container d-flex justify-content-center",
                              },
                              [_c("csp-loading-indicator")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.documentsLoaded
                          ? _c(
                              "div",
                              [
                                _vm._l(
                                  _vm.documentsPerGroup,
                                  function (documents, groupKey) {
                                    return _c(
                                      "div",
                                      { key: groupKey },
                                      [
                                        _c("h2", [
                                          _vm._v(
                                            _vm._s(_vm.groupName(groupKey))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          staticClass: "mb-3",
                                          attrs: {
                                            fields: _vm.tableFields,
                                            items: documents,
                                            striped: true,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "table-colgroup",
                                                fn: function (scope) {
                                                  return _vm._l(
                                                    scope.fields,
                                                    function (field) {
                                                      return _c("col", {
                                                        key: field.key,
                                                        style: {
                                                          width:
                                                            field.width ??
                                                            "auto",
                                                        },
                                                      })
                                                    }
                                                  )
                                                },
                                              },
                                              {
                                                key: "cell(name)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(data.item.name)
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    data.item.labelExtension
                                                      ? _c(
                                                          "i",
                                                          {
                                                            staticStyle: {
                                                              "white-space":
                                                                "normal",
                                                            },
                                                          },
                                                          [
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                                    " +
                                                                _vm._s(
                                                                  data.item
                                                                    .labelExtension
                                                                ) +
                                                                "\n                                "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    data.item
                                                      .childDocumentsSelectable
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "white-space":
                                                                "normal",
                                                            },
                                                          },
                                                          _vm._l(
                                                            data.item
                                                              .childDocumentsSelectable,
                                                            function (
                                                              selectable
                                                            ) {
                                                              return _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  key:
                                                                    data.item
                                                                      .id +
                                                                    "_" +
                                                                    selectable.id,
                                                                  model: {
                                                                    value:
                                                                      selectable.checked,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          selectable,
                                                                          "checked",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "selectable.checked",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        " +
                                                                      _vm._s(
                                                                        selectable.label
                                                                      ) +
                                                                      "\n                                    "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(actions)",
                                                fn: function (data) {
                                                  return [
                                                    _vm._l(
                                                      data.item.formats,
                                                      function (
                                                        formatLabel,
                                                        format
                                                      ) {
                                                        return [
                                                          format !== "mail"
                                                            ? _c(
                                                                "b-button",
                                                                {
                                                                  key: format,
                                                                  attrs: {
                                                                    href: _vm.getDocumentCreationPath(
                                                                      data.item,
                                                                      format
                                                                    ),
                                                                    size: "sm",
                                                                    variant:
                                                                      "primary",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        " +
                                                                      _vm._s(
                                                                        formatLabel
                                                                      ) +
                                                                      "\n                                    "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          format === "mail"
                                                            ? _c(
                                                                "b-button",
                                                                {
                                                                  key: format,
                                                                  attrs: {
                                                                    size: "sm",
                                                                    variant:
                                                                      "primary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.loadMailAndOpenMailModal(
                                                                          data.item,
                                                                          format
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        " +
                                                                      _vm._s(
                                                                        formatLabel
                                                                      ) +
                                                                      "\n                                    "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      }
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.firmSpecificDocumentList.length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _c("h2", [
                                          _vm._v("Firmenspezifische Dokumente"),
                                        ]),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          staticClass: "mb-3",
                                          attrs: {
                                            fields: _vm.tableFields,
                                            items: _vm.firmSpecificDocumentList,
                                            striped: true,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "table-colgroup",
                                                fn: function (scope) {
                                                  return _vm._l(
                                                    scope.fields,
                                                    function (field) {
                                                      return _c("col", {
                                                        key: field.key,
                                                        style: {
                                                          width:
                                                            field.width ??
                                                            "auto",
                                                        },
                                                      })
                                                    }
                                                  )
                                                },
                                              },
                                              {
                                                key: "cell(name)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.attributes
                                                            .name
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(actions)",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        key: "mail",
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadMailAndOpenMailModalFirmSpecificDocument(
                                                              data.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                    MAIL\n                                "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "modal-footer",
            fn: function ({ ok }) {
              return [
                _c(
                  "b-button",
                  { attrs: { variant: "secondary" }, on: { click: ok } },
                  [_vm._v("Schließen")]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.isModalOpen,
          callback: function ($$v) {
            _vm.isModalOpen = $$v
          },
          expression: "isModalOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }